import { connect } from "react-redux";
import {
  getChiTietHopDong,
  getLichSuHopDong,
  getLichSuVayThemTraBotGoc,
  getListTaiSanCamCo,
  getLichSuNoPhaiThu,
  getListGhiChu,
} from "actions/ChiTietHopDong";
import {
  getLichSuGiaHanChoVay,
  getLanDongLaiChoVay,
} from "actions/QuanLyChoVay";
import ChiTietHopDong from "components/CommonComponent/ChiTietHopDong";

const mapStateToProps = (state) => ({
  chitiethopdong: state.chitiethopdong,
  quanlychovay: state.quanlychovay,
  cauhinh: state.cauhinh,
});

const mapDispatchToProps = (dispatch) => ({
  getChiTietHopDong: (dataSearch) => dispatch(getChiTietHopDong(dataSearch)),
  getLichSuHopDong: (dataSearch) => dispatch(getLichSuHopDong(dataSearch)),
  getLichSuVayThemTraBotGoc: (dataSearch) =>
    dispatch(getLichSuVayThemTraBotGoc(dataSearch)),
  getLichSuGiaHanChoVay: (dataSearch) =>
    dispatch(getLichSuGiaHanChoVay(dataSearch)),
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
  getListTaiSanCamCo: (dataSearch) => dispatch(getListTaiSanCamCo(dataSearch)),
  getLichSuNoPhaiThu: (dataSearch) => dispatch(getLichSuNoPhaiThu(dataSearch)),
  getListGhiChu: (dataSearch) => dispatch(getListGhiChu(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChiTietHopDong);
